<template>
  <div class="app-filter-orders">
    <div class="app-filter-orders__group">
      <app-toggler-control
        title="Отгруженные"
        tooltip="Подсказка"
        class="app-filter-orders__item"
        v-model="formData.isShipped"
      ></app-toggler-control>
      <app-calendar-field
        placeholder="01.01.2021 - 01.05.2021"
        title="Выберите период"
        tooltip="Выберите период"
        class="app-filter-orders__item"
        v-model="formData.period"
        isRange
        isDropdown
      ></app-calendar-field>
    </div>
    <app-button-control
      @click="handlerClearBtn"
      class="app-filter-orders__btn-clear"
      type="white"
      isUppercase
      isWhiteLoader
    >
      Сбросить
    </app-button-control>
  </div>
</template>

<script>
// TODO: Заготовка под основной компоент блоков фильтрации
export default {
  name: 'AppFilterOrders',
  components: {
    AppButtonControl: () => import('@/components/ui/AppButtonControl'),
    AppTogglerControl: () => import('@/components/ui/AppTogglerControl'),
    AppCalendarField: () => import('@/components/ui/AppCalendarField'),
  },
  props: {
    isShipped: {
      type: Boolean,
    },
    period: {
      type: Object,
      default() {
        return {
          start: '',
          end: '',
        };
      },
    },
  },
  data: (vm) => ({
    formData: {
      isShipped: vm.isShipped,
      period: vm.period,
    },
  }),
  watch: {
    formData: {
      deep: true,
      handler() {
        this.changeData();
      },
    },
  },
  methods: {
    /**
     * Очистка фильтра (может вызываться из вне)
     */
    clear() {
      this.formData.isShipped = false;
      this.formData.period = null;
    },
    handlerClearBtn() {
      this.clear();
      this.$emit('clear');
    },
    /**
     * Изменение данных
     */
    changeData() {
      this.$emit('change', this.formData);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-filter-orders {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  margin-bottom: 11px;

  @include media-xxs() {
    flex-direction: column;
  }

  &__group {
    display: flex;

    @include media-xxs() {
      flex-direction: column;
    }
  }

  &__item {
    min-width: 198px;
    margin-right: 12px;
    margin-bottom: 15px;

    @include media-xxs() {
      width: 100% !important;
      min-width: auto;
    }

    &:last-of-type {
      margin-right: 0;
    }
  }

  &__btn-clear {
    height: 60px;
    margin-bottom: 15px;
    color: $accent !important;
  }
}
</style>
